/* eslint-disable */
import axios, { AxiosInstance } from "axios";
import { toast } from "react-toastify";
import i18n from "../../i18n";
import { URL_SERVICE_PERSON, baseUri } from "../../uri";
import {
  CREATE_FUND,
  GET_ALL_FUNDS,
  GET_CLIENTS,
  GET_FUND,
  GET_PART,
  UPDATE_FUND,
  GET_ALL_ISSUER_SIGNERS,
  GET_ALL_PRODUCT_SIGNERS,
  ADD_ISSUER_SIGNER,
  ADD_PRODUCT_SIGNER,
  CREATE_PERSON,
  DELETE_ISSUER_SIGNER,
  DELETE_PRODUCT_SIGNER,
  UPDATE_ISSUER_SIGNER,
  UPDATE_PRODUCT_SIGNER,
  UPDATE_PERSON,
  ADD_FUND_PART,
  UPDATE_FUND_PART,
  GET_BS_TEMPLATES,
  GET_TEMPLATE_BY_NAME,
  ADD_HTML_TEMPLATES,
  ADD_JSON_TEMPLATES,
  ADD_NET_ASSET_VALUE,
  DELETE_NET_ASSET_VALUE,
  GET_NET_ASSET_VALUE,
  GET_ENGAGEMENT_LETTER_TEMPLATES,
  GET_ENGAGEMENT_LETTER_BY_NAME,
  ADD_HTML_ENGAGEMENT_TEMPLATES,
  ADD_JSON_ENGAGEMENT_TEMPLATES,
  ADD_HTML_MIFID_TEMPLATES,
  ADD_HTML_SEC_TEMPLATES,
  ADD_HTML_FCA_TEMPLATES,
  ADD_HTML_LSFIN_TEMPLATES,
  GET_MIFID_LETTER_BY_NAME,
  GET_SEC_LETTER_BY_NAME,
  GET_FCA_LETTER_BY_NAME,
  GET_LSFIN_LETTER_BY_NAME,
  GET_MIFID_LETTER_TEMPLATES,
  GET_SEC_LETTER_TEMPLATES,
  GET_FCA_LETTER_TEMPLATES,
  GET_LSFIN_LETTER_TEMPLATES,
  ADD_JSON_MIFID_TEMPLATES,
  ADD_JSON_SEC_TEMPLATES,
  ADD_JSON_FCA_TEMPLATES,
  ADD_JSON_LSFIN_TEMPLATES,
  ADD_HTML_CONVENTION_TEMPLATES,
  GET_CONVENTION_LETTER_BY_NAME,
  GET_CONVENTION_LETTER_TEMPLATES,
  ADD_JSON_CONVENTION_TEMPLATES,
  GET_INITIAL_CONTACT_CONTRACT_TEMPLATES,
  GET_INITIAL_CONTACT_CONTRACT_BY_NAME,
  ADD_HTML_INITIAL_CONTACT_CONTRACT_TEMPLATES,
  ADD_JSON_INITIAL_CONTACT_CONTRACT_TEMPLATES,
  GET_ALL_FUNDS_IN_TEAM,
  ADD_FUND_IN_TEAM,
  DELETE_FUND_IN_TEAM,
  UPDATE_PART_TEXT_TRANSLATION,
  GET_COLORS,
  GET_NET_ASSET_PART_VALUE,
  ADD_NET_ASSET_PART_VALUE,
  DELETE_NET_ASSET_PART_VALUE,
  GET_TRANSLATION_BY_KEY,
  GET_TRANSFER_TEMPLATES,
} from "../actionTypes";
import { getHeaders } from "./users.actions";

let axiosRequestBaseUrl: AxiosInstance;

let axiosRequestServicePersonUrl: AxiosInstance;

export const initAxiosFund = () => {
  getHeaders();

  axiosRequestBaseUrl = axios.create({
    baseURL: baseUri,
    headers: { ...axios.defaults.headers.common }
  });

  axiosRequestServicePersonUrl = axios.create({
    baseURL: URL_SERVICE_PERSON,
    timeout: 1000,
    headers: { ...axios.defaults.headers.common }
  });

};

export const addHTMLInitialContactContractTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v1/initial-contact-contracts/template/html`,
          file
        );
        dispatch({
          type: ADD_HTML_INITIAL_CONTACT_CONTRACT_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addJSONInitialContactContractTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v1/initial-contact-contracts/template/json`,
          file
        );
        dispatch({
          type: ADD_JSON_INITIAL_CONTACT_CONTRACT_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const getInitialContactContractByName =
  (fileName: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v1/initial-contact-contracts/template/${fileName}`
        );
        dispatch({
          type: GET_INITIAL_CONTACT_CONTRACT_BY_NAME,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const getInitialContactContractTemplateList =
  () => async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axiosRequestBaseUrl.get(
        `/service-doc-generation/v1/initial-contact-contracts/template/list`
      );
      dispatch({
        type: GET_INITIAL_CONTACT_CONTRACT_TEMPLATES,
        payload: res.data,
      });
    } catch (e) { }
  };
export const addHTMLEngagementTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v1/engagement-letters/template/html`,
          file
        );
        dispatch({
          type: ADD_HTML_ENGAGEMENT_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addJSONEngagementTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v1/engagement-letters/template/json`,
          file
        );
        dispatch({
          type: ADD_JSON_ENGAGEMENT_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const getEngagementLetterByName =
  (fileName: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v1/engagement-letters/template/${fileName}`
        );
        dispatch({
          type: GET_ENGAGEMENT_LETTER_BY_NAME,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const getEngagementLetterTemplateList =
  () => async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axiosRequestBaseUrl.get(
        `/service-doc-generation/v1/engagement-letters/template/list`
      );
      dispatch({
        type: GET_ENGAGEMENT_LETTER_TEMPLATES,
        payload: res.data,
      });
    } catch (e) { }
  };

export const addHTMLMifidTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v2/MIFID/template/html`,
          file
        );
        dispatch({
          type: ADD_HTML_MIFID_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addHTMLSecTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v2/SEC/template/html`,
          file
        );
        dispatch({
          type: ADD_HTML_SEC_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addHTMLFcaTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v2/FCA/template/html`,
          file
        );
        dispatch({
          type: ADD_HTML_FCA_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addHTMLsfinTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v2/LSFIN/template/html`,
          file
        );
        dispatch({
          type: ADD_HTML_LSFIN_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addJSONMifidTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v2/MIFID/template/json`,
          file
        );
        dispatch({
          type: ADD_JSON_MIFID_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addJSONSecTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v2/SEC/template/json`,
          file
        );
        dispatch({
          type: ADD_JSON_SEC_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addJSONFcaTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v2/FCA/template/json`,
          file
        );
        dispatch({
          type: ADD_JSON_FCA_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addJSONLsfinTemplates =
  (file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v2/LSFIN/template/json`,
          file
        );
        dispatch({
          type: ADD_JSON_LSFIN_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const getMifidLetterByName =
  (fileName: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v2/MIFID/template/${fileName}`
        );
        dispatch({
          type: GET_MIFID_LETTER_BY_NAME,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const getMifidLetterTemplateList =
  () => async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axiosRequestBaseUrl.get(
        `/service-doc-generation/v2/MIFID/template/list`
      );
      dispatch({
        type: GET_MIFID_LETTER_TEMPLATES,
        payload: res.data,
      });
    } catch (e) { }
  };

export const getSecLetterTemplateList =
  () => async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axiosRequestBaseUrl.get(
        `/service-doc-generation/v2/SEC/template/list`
      );
      dispatch({
        type: GET_SEC_LETTER_TEMPLATES,
        payload: res.data,
      });
    } catch (e) { }
  };

export const getSecLetterByName =
  (fileName: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v2/SEC/template/${fileName}`
        );
        dispatch({
          type: GET_SEC_LETTER_BY_NAME,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getFcaLetterTemplateList =
  () => async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axiosRequestBaseUrl.get(
        `/service-doc-generation/v2/FCA/template/list`
      );
      dispatch({
        type: GET_FCA_LETTER_TEMPLATES,
        payload: res.data,
      });
    } catch (e) { }
  };

export const getFcaLetterByName =
  (fileName: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v2/FCA/template/${fileName}`
        );
        dispatch({
          type: GET_FCA_LETTER_BY_NAME,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getLsfinLetterTemplateList =
  () => async (dispatch: (arg0: { type: any; payload: void }) => void) => {
    try {
      const res = await axiosRequestBaseUrl.get(
        `/service-doc-generation/v2/LSFIN/template/list`
      );
      dispatch({
        type: GET_LSFIN_LETTER_TEMPLATES,
        payload: res.data,
      });
    } catch (e) { }
  };

export const getLsfinLetterByName =
  (fileName: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v2/LSFIN/template/${fileName}`
        );
        dispatch({
          type: GET_LSFIN_LETTER_BY_NAME,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const addHTMLConventionTemplates =
  (contractType: string, file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v1/distribution-agreements/template/${contractType}/html`,
          file
        );
        dispatch({
          type: ADD_HTML_CONVENTION_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const addJSONConventionTemplates =
  (contractType: string, file: FormData) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v1/distribution-agreements/template/${contractType}/json`,
          file
        );
        dispatch({
          type: ADD_JSON_CONVENTION_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getConventionLetterByName =
  (contractType: string, fileName: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v1/distribution-agreements/template/${contractType}/${fileName}`
        );
        dispatch({
          type: GET_CONVENTION_LETTER_BY_NAME,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getConventionLetterTemplateList =
  (contractType: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v1/distribution-agreements/template/${contractType}/list`
        );
        dispatch({
          type: GET_CONVENTION_LETTER_TEMPLATES,
          payload: res.data,
        });
      } catch (e) { }
    };

export const getBSTemplateList =
  (partId: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v1/termsheets/template/parts/${partId}/list`
        );
        dispatch({
          type: GET_BS_TEMPLATES,
          payload: res.data,
        });
      } catch (e) { }
    };

export const getTransferTemplateList =
  (partId: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v1/transfer/template/parts/${partId}/list`
        );
        dispatch({
          type: GET_TRANSFER_TEMPLATES,
          payload: res.data,
        });
      } catch (e) { }
    };
export const getTemplateByName =
  (partId: string, fileName: string, type: string = "termsheets") =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.get(
          `/service-doc-generation/v1/${type}/template/parts/${partId}/${fileName}`
        );
        dispatch({
          type: GET_TEMPLATE_BY_NAME,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addHTMLTemplates =
  (partId: any, file: FormData, type: string = "termsheets") =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v1/${type}/template/parts/${partId}/html`,
          file
        );
        dispatch({
          type: ADD_HTML_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addJSONTemplates =
  (partId: any, file: FormData, type: string = "termsheets") =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestBaseUrl.put(
          `/service-doc-generation/v1/${type}/template/parts/${partId}/json`,
          file
        );
        dispatch({
          type: ADD_JSON_TEMPLATES,
          payload: res.data,
        });
        toast.success(i18n.t("DOCUMENT_DOWNLOADED_SUCCESSFULLY"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getClients =
  (name: string) =>
    async (dispatch: (arg0: { type: any; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/persons/name?nameContains=${name}`
        );
        dispatch({
          type: GET_CLIENTS,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const createFund =
  (fund: any) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.post(
          `service-person/v1/persons/funds`,
          fund
        );
        window.location.href = `${baseUri}/admin/funds/details?id=${res?.data?.person?.id}`;
        dispatch({
          type: CREATE_FUND,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getFund =
  (fundId?: any) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const fundPersonId = new URLSearchParams(window.location.search).get(
          "id"
        );
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/persons/${fundId || fundPersonId}/fund`
        );
        dispatch({
          type: GET_FUND,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getPart =
  (fundId: any, partId?: any) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/persons/${fundId}/fund/parts/${partId}`
        );
        dispatch({
          type: GET_PART,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getAllFundsInTeam =
  (teamId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/persons/teams/${teamId}/funds`
        );
        dispatch({
          type: GET_ALL_FUNDS_IN_TEAM,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const postFundInTeam =
  (teamId: string, fundId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.post(
          `service-person/v1/persons/teams/${teamId}/funds/${fundId}`
        );
        dispatch({
          type: ADD_FUND_IN_TEAM,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const deleteFundInTeam =
  (teamId: string, fundId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.delete(
          `service-person/v1/persons/teams/${teamId}/funds/${fundId}`
        );
        dispatch({
          type: DELETE_FUND_IN_TEAM,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getAllFunds =
  (filterOpened?: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/persons/funds${filterOpened ? "?filterOpened=" + filterOpened : ""
          }`
        );
        dispatch({
          type: GET_ALL_FUNDS,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getAllIssuerSigners =
  (fundPersonId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/persons/settings/fund/${fundPersonId}/issuer-signers`
        );
        dispatch({
          type: GET_ALL_ISSUER_SIGNERS,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const createPersonSigner =
  (personInfo: any, signerType: any) =>
    async (
      dispatch: (arg0: { type: string; payload: void; signer: any }) => void
    ) => {
      try {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const fundPersonId = urlParams.get("id");
        let res: any = {};
        let signer: any = {};
        await axiosRequestServicePersonUrl
          .post(`service-person/v1/persons`, personInfo)
          .then((response: any) => {
            res = response;
            if (signerType === "ISSUER") {
              signer = axiosRequestServicePersonUrl.post(
                `service-person/v1/persons/${fundPersonId}/fund/issuer-signers`,
                {
                  personId: response.data.id,
                  defaultSigner: personInfo.defaultSigner,
                  roleFunction: personInfo.roleFunction,
                  visibleOperations: personInfo.visibleOperations,
                }
              );
            } else if (signerType === "PRODUCT") {
              signer = axiosRequestServicePersonUrl.post(
                `service-person/v1/persons/${fundPersonId}/fund/product-signers`,
                {
                  personId: response.data.id,
                  defaultSigner: personInfo.defaultSigner,
                  roleFunction: personInfo.roleFunction,
                }
              );
            }
          });
        dispatch({
          type: CREATE_PERSON,
          payload: res.data,
          signer: signer.data,
        });
        toast.success(i18n.t("SUCCESS"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const updatePersonSigner =
  (personId: any, personInfo: any, signerType: string) =>
    async (
      dispatch: (arg0: { type: string; payload: void; signer: any }) => void
    ) => {
      try {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const fundPersonId = urlParams.get("id");
        let res: any = {};
        let signer: any = {};
        personInfo.defaultSigner = JSON.parse(personInfo.defaultSigner);
        await axiosRequestServicePersonUrl
          .put(`service-person/v1/persons/${personId}`, personInfo)
          .then((response: any) => {
            res = response;
            if (signerType === "ISSUER") {
              signer = axiosRequestServicePersonUrl
                .put(
                  `service-person/v1/persons/${fundPersonId}/fund/issuer-signers/${personId}`,
                  {
                    personId: response.data.id,
                    defaultSigner: JSON.parse(personInfo.defaultSigner),
                    roleFunction: personInfo.roleFunction,
                    visibleOperations: personInfo.visibleOperations,
                  }
                )
                .then((r) => (signer = r));
            } else if (signerType === "PRODUCT") {
              signer = axiosRequestServicePersonUrl
                .put(
                  `service-person/v1/persons/${fundPersonId}/fund/product-signers/${personId}`,
                  {
                    personId: response.data.id,
                    defaultSigner: JSON.parse(personInfo.defaultSigner),
                    roleFunction: personInfo.roleFunction,
                  }
                )
                .then((r) => (signer = r));
            }
          });
        dispatch({
          type: UPDATE_PERSON,
          payload: res.data,
          signer: signer.data,
        });
        toast.success(i18n.t("SUCCESS"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addFundPart =
  (partInfo: any, fundPersonId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.post(
          `service-person/v1/persons/${fundPersonId}/fund/parts`,
          partInfo
        );
        dispatch({
          type: ADD_FUND_PART,
          payload: res.data,
        });
        toast.success(i18n.t("SUCCESS"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const updateFundPart =
  (partInfo: any, fundPersonId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.put(
          `service-person/v1/persons/${fundPersonId}/fund/parts/${partInfo.id}`,
          partInfo
        );
        dispatch({
          type: UPDATE_FUND_PART,
          payload: res.data,
        });
        toast.success(i18n.t("SUCCESS"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addIssuerSigner =
  (issuerInfo: any, fundPersonId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.post(
          `service-person/v1/persons/${fundPersonId}/fund/issuer-signers`,
          issuerInfo
        );
        dispatch({
          type: ADD_ISSUER_SIGNER,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const updateIssuerSigner =
  (signerPersonId: any, fundPersonId: any, issuerInfo: any, checked: any) =>
    async (
      dispatch: (arg0: { type: string; payload: void; signer: any }) => void
    ) => {
      try {
        const signersInfo = {
          personId: issuerInfo.personId,
          defaultSigner: checked,
          roleFunction: issuerInfo.roleFunction,
          visibleOperations: issuerInfo.visibleOperations,
        };
        let res: any = {};
        let signer: any = {};
        await axiosRequestServicePersonUrl
          .put(`service-person/v1/persons/${signerPersonId}`, issuerInfo)
          .then((response: any) => {
            res = response;
            signer = axiosRequestServicePersonUrl.put(
              `service-person/v1/persons/${fundPersonId}/fund/issuer-signers/${signerPersonId}`,
              signersInfo
            );
          });
        dispatch({
          type: UPDATE_ISSUER_SIGNER,
          payload: res.data,
          signer: signer.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const deleteIssuerSigner =
  (signerPersonId: any, fundPersonId: any) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.delete(
          `service-person/v1/persons/${fundPersonId}/fund/issuer-signers/${signerPersonId}`
        );
        dispatch({
          type: DELETE_ISSUER_SIGNER,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const addProductSigner =
  (productSignerInfo: any, fundPersonId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.post(
          `service-person/v1/persons/${fundPersonId}/fund/product-signers`,
          productSignerInfo
        );
        dispatch({
          type: ADD_PRODUCT_SIGNER,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const updateProductSigner =
  (signerPersonId: any, fundPersonId: any, productInfo: any, checked: any) =>
    async (
      dispatch: (arg0: { type: string; payload: void; signer: any }) => void
    ) => {
      try {
        const signersInfo = {
          personId: productInfo.id,
          defaultSigner: checked,
          roleFunction: productInfo.roleFunction,
        };
        let res: any = {};
        let signer: any = {};
        await axiosRequestServicePersonUrl
          .put(`service-person/v1/persons/${signerPersonId}`, productInfo)
          .then((response: any) => {
            res = response;
            signer = axiosRequestServicePersonUrl.put(
              `service-person/v1/persons/${fundPersonId}/fund/product-signers/${signerPersonId}`,
              signersInfo
            );
          });
        dispatch({
          type: UPDATE_PRODUCT_SIGNER,
          payload: res.data,
          signer: signer.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const deleteProductSigner =
  (signerPersonId: any, fundPersonId: any) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.delete(
          `service-person/v1/persons/${fundPersonId}/fund/product-signers/${signerPersonId}`
        );
        dispatch({
          type: DELETE_PRODUCT_SIGNER,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const getAllProductSigners =
  (fundPersonId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/persons/${fundPersonId}/fund/product-signers`
        );
        dispatch({
          type: GET_ALL_PRODUCT_SIGNERS,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const updateFund =
  (fund: any) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const fundPersonId = new URLSearchParams(window.location.search).get(
          "id"
        );
        const res = await axiosRequestServicePersonUrl.put(
          `service-person/v1/persons/${fundPersonId}/funds`,
          fund
        );
        dispatch({
          type: UPDATE_FUND,
          payload: res.data,
        });
        toast.success(i18n.t("SUCCESS"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addNetAssetValue =
  (netValue: any, fundPersonId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.post(
          `service-person/v1/persons/${fundPersonId}/fund/net-asset-value`,
          netValue
        );
        dispatch({
          type: ADD_NET_ASSET_VALUE,
          payload: res.data,
        });
        toast.success(i18n.t("SUCCESS"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const addNetAssetPartValue =
  (netValue: any, fundPersonId: string, partId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.post(
          `service-person/v1/persons/${fundPersonId}/fund/parts/${partId}/net-asset-value`,
          netValue
        );
        dispatch({
          type: ADD_NET_ASSET_PART_VALUE,
          payload: res.data,
        });
        toast.success(i18n.t("SUCCESS"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const getNetAssetValue =
  (fundPersonId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/persons/${fundPersonId}/fund/net-asset-value`
        );
        dispatch({
          type: GET_NET_ASSET_VALUE,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

export const getNetAssetPartValue =
  (fundPersonId: string, partId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/persons/${fundPersonId}/fund/parts/${partId}/net-asset-value`
        );
        dispatch({
          type: GET_NET_ASSET_PART_VALUE,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const deleteNetAssetValue =
  (fundPersonId: string, netAssetValueId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.delete(
          `service-person/v1/persons/${fundPersonId}/fund/net-asset-value/${netAssetValueId}`
        );
        dispatch({
          type: DELETE_NET_ASSET_VALUE,
          payload: res.data,
        });
        toast.success(i18n.t("SUCCESS"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const deleteNetAssetPartValue =
  (fundPersonId: string, partId: string, netAssetValueId: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.delete(
          `service-person/v1/persons/${fundPersonId}/fund/parts/${partId}/net-asset-value/${netAssetValueId}`
        );
        dispatch({
          type: DELETE_NET_ASSET_PART_VALUE,
          payload: res.data,
        });
        toast.success(i18n.t("SUCCESS"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const getColors =
  () =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/funds/colors`
        );
        dispatch({
          type: GET_COLORS,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const updatePartTextTranslation =
  (key: any, translation: any) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.put(
          `service-person/v1/translations/part/${key}`,
          translation
        );
        dispatch({
          type: UPDATE_PART_TEXT_TRANSLATION,
          payload: res.data,
        });
        toast.success(i18n.t("SUCCESS"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
export const getTranslationByPart =
  (key: string) =>
    async (dispatch: (arg0: { type: string; payload: void }) => void) => {
      try {
        const res = await axiosRequestServicePersonUrl.get(
          `service-person/v1/translations/all/${key}`
        );
        dispatch({
          type: GET_TRANSLATION_BY_KEY,
          payload: res.data,
        });
      } catch (e) {
        toast.error(i18n.t("ERROR_MESSAGES.GENERIC_ERROR"), {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };

